import { CacheableState } from '@utils/cacheable-state';
import { AppUser } from '../../domain';

export interface UsersState {
  allUsers: CacheableState<Array<AppUser>>;
  sendLink: CacheableState<Array<any>>;
  uploadFile: CacheableState<Array<any>>;
  usersCount: CacheableState<Array<any>>;
  userDetails: CacheableState<AppUser>;
  updateUser: CacheableState<Array<any>>;
  deleteUser: CacheableState<Array<any>>;
  forgotPassword: CacheableState<Array<any>>;
  resetPasswordCode: string;
  resetPasswordEmail: string;
  resetPassword: CacheableState<Array<any>>;
  updateCompanyManager: CacheableState<Array<any>>;
  confirmAccount: CacheableState<Array<any>>;
  createCompanyManager: CacheableState<boolean>;
  resendEmail: CacheableState<Array<any>>;
  isAdmin: boolean | null;
}

export function usersInitialState(): UsersState {
  return {
    allUsers: initialDataSubState().allUsers,
    sendLink: initialDataSubState().sendLink,
    uploadFile: initialDataSubState().uploadFile,
    usersCount: initialDataSubState().usersCount,
    userDetails: initialDataSubState().userDetails,
    updateUser: initialDataSubState().updateUser,
    deleteUser: initialDataSubState().deleteUser,
    forgotPassword: initialDataSubState().forgotPassword,
    resetPasswordCode: initialDataSubState().resetPasswordCode,
    resetPasswordEmail: initialDataSubState().resetPasswordEmail,
    resetPassword: initialDataSubState().resetPassword,
    updateCompanyManager: initialDataSubState().updateCompanyManager,
    confirmAccount: initialDataSubState().confirmAccount,
    createCompanyManager: initialDataSubState().createCompanyManager,
    resendEmail: initialDataSubState().resendEmail,
    isAdmin: initialDataSubState().isAdmin,
  };
}
export function initialDataSubState(): UsersState {
  return {
    allUsers: new CacheableState(),
    sendLink: new CacheableState(),
    uploadFile: new CacheableState(),
    usersCount: new CacheableState(),
    userDetails: new CacheableState(),
    updateUser: new CacheableState(),
    deleteUser: new CacheableState(),
    forgotPassword: new CacheableState(),
    resetPasswordCode: '',
    resetPasswordEmail: '',
    resetPassword: new CacheableState(),
    updateCompanyManager: new CacheableState(),
    confirmAccount: new CacheableState(),
    createCompanyManager: new CacheableState(),
    resendEmail: new CacheableState(),
    isAdmin: null,
  };
}
